import { roundedCorners } from '@utils'
import styled from 'styled-components'

export const YouTubePlayerMain = styled.section`
  position: relative;
  width: 100%;
  height: 100%;
  ${roundedCorners}

  .youtube-player,
  iframe {
    width: 100%;
    height: 100%;
  }
`
